import { render, staticRenderFns } from "./GuppyChatTextMessage.vue?vue&type=template&id=91dad9f4&"
import script from "./GuppyChatTextMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatTextMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatTextMessage.vue?vue&type=style&index=0&id=91dad9f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports